import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { signup } from '../../services/user.services';
import SuccessOverlay from '../../user/UserComponents/overlays/SuccessOverlay';
import ErrorOverlay from '../../user/UserComponents/overlays/ErrorOverlay';
// import HeaderBackButton from '../../components/HeaderBackButton';
import './signup.css';
import mainImg from "../../user/pages/assets/dashboard.png";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const Signup = ({ history }) => {
    const initialState = {
        userName: '',
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        contactNumber: '',
        organizationName: '',
    };

    const [formData, setFormData] = useState(initialState);
    const [visible, setVisible] = useState(false);
    const [warningVisible, setWarningVisible] = useState(false);
    const [displayPhone, setDisplayPhone] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const [passwordHidden, setPasswordHidden] = useState(true);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const user = useSelector(state => state.auth.user);

    const toggleHidePassword = () => setPasswordHidden(!passwordHidden);

    const toggleSuccessModal = () => {
        setVisible(true);
        setTimeout(() => {
            history.push('/login');
            setVisible(false);
        }, 1500);
    };

    const toggleWarningModal = () => {
        setWarningVisible(true);
        setTimeout(() => setWarningVisible(false), 1200);
    };

const handleFormChange = (eOrName, value) => {
    if (typeof eOrName === "string") {
        setFormData(prevState => ({ ...prevState, [eOrName]: value }));
    } else {
        const { name, value } = eOrName.target;
        setFormData(prevState => ({ ...prevState, [name]: value }));
    }
};

    useEffect(() => {
        let phoneLength = formData.contactNumber.length;
        let formattedNumber = '';

        if (phoneLength < 4) {
            formattedNumber = formData.contactNumber;
        } else if (phoneLength > 3 && phoneLength < 7) {
            formattedNumber = `(${formData.contactNumber.slice(0, 3)}) ${formData.contactNumber.slice(3)}`;
        } else {
            formattedNumber = `(${formData.contactNumber.slice(0, 3)}) ${formData.contactNumber.slice(3, 6)}-${formData.contactNumber.slice(6, 12)}`;
        }

        setDisplayPhone(formattedNumber);
    }, [formData.contactNumber]);

    const handleCreate = async () => {
        try {
            setLoading(true);
            await signup(formData, user?.token);
            toggleSuccessModal();
        } catch (e) {
            setError(e);
           console.error('Full error details:', e.response?.data);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
    handleFormChange('userName', formData.firstName + " " + formData.lastName)
  }, [formData.firstName, formData.lastName])

    return (
        <div className="login">
            <ErrorOverlay visible={!!error} error={error} onBackdropPress={() => setError(null)} />
            <SuccessOverlay visible={visible} message="User has been created successfully!" onClose={toggleSuccessModal} />
            <SuccessOverlay visible={warningVisible} message="Email must be accurate!" onClose={toggleWarningModal} />

            <div className="topContentSignUp">
                {/* <div className='imageBoxHeader'>
          <img src={headerImg} className="headerImageTop" alt="Dashboard Header" />
        </div> */}
                <h2 className="welcomeSubHeading" style={{fontSize: "35px"}}> SIGN-UP </h2>
                <div className="imageBoxMain">
                    <img src={mainImg} style={{width: "120px"}}alt="Dashboard Header" />
                </div>
            </div>
            <div className="login-box">
                <div className="user-box">
                    {/* <input type="text" name="userName" placeholder="User Name" value={formData.userName} onChange={handleFormChange} /> */}
                    <input type="text" name="firstName" placeholder="First Name" value={formData.firstName} onChange={handleFormChange} />
                    <input type="text" name="lastName" placeholder="Last Name" value={formData.lastName} onChange={handleFormChange} />
                    <input type="email" name="email" placeholder="User Email Address" value={formData.email} onChange={handleFormChange} />
                    <input type="text" name="organizationName" placeholder="Organization Name" value={formData.organizationName} onChange={handleFormChange} />
                    <input
                        type="tel"
                        name="contactNumber"
                        placeholder="Contact Number"
                        value={isFocused ? formData.contactNumber : displayPhone}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        onChange={handleFormChange}
                    />
                    <div className="signup-password-container">
                        <input
                            type={passwordHidden ? "password" : "text"}
                            name="password"
                            placeholder="Password"
                            value={formData.password}
                            onChange={handleFormChange}
                        />
                        <span className="signup-eye-icon" onClick={toggleHidePassword}>
                            {passwordHidden ? <FaEyeSlash /> : <FaEye />}
                        </span>
                    </div>
                </div>
            </div>
            <div className="container">
                <button className="signup-button" onClick={handleCreate} disabled={loading}>
                    {loading ? 'Signing Up...' : 'SIGN UP'}
                </button>
            </div>
        </div>
    );
};

export default Signup;